import React, { useEffect, useState } from "react";
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";

const SaveTheDate = () => {
  const targetDate = new Date("March 21, 2026 18:00:00").getTime();
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        clearInterval(timer);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        ),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const StatBox = ({ value, label }) => (
    <div
      className="flex flex-col items-center
      bg-gradient-to-br from-blue-600/20 to-indigo-600/20
      backdrop-blur-xl rounded-3xl px-7 md:px-8 py-6
      shadow-2xl hover:scale-105 transition-all duration-300
      border border-white/20"
    >
      <h2 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">
        {value}
      </h2>
      <p className="mt-2 text-sm md:text-lg text-blue-100 tracking-wide">
        {label}
      </p>
    </div>
  );

  return (
    <section
      className=" flex items-center justify-center
      bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950
      text-white px-4 py-20"
    >
      <div className="max-w-6xl w-full text-center flex flex-col items-center gap-14">
        {/* TITLE */}
        <h1 className="text-3xl md:text-5xl font-extrabold tracking-wide drop-shadow-xl">
          Remaining days
        </h1>

        {/* COUNTDOWN */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6 w-full max-w-4xl">
          <StatBox value={timeLeft.days ?? 0} label="Days" />
          <StatBox value={timeLeft.hours ?? 0} label="Hours" />
          <StatBox value={timeLeft.minutes ?? 0} label="Minutes" />
          <StatBox value={timeLeft.seconds ?? 0} label="Seconds" />
        </div>

        {/* EVENT DETAILS */}
        <div
          className="bg-gradient-to-br from-blue-700/20 to-indigo-700/20
          backdrop-blur-xl rounded-3xl p-7 md:p-12 shadow-2xl
          w-full max-w-4xl border border-white/20"
        >
          <div
            className="flex flex-col md:flex-row items-center justify-center
            gap-6 md:gap-10 text-base md:text-xl text-blue-100"
          >
            <div className="flex items-center gap-3">
              <FaCalendarAlt className="text-white" />
              <span>March 21, 2026</span>
            </div>

            <div className="flex items-center gap-3">
              <FaClock className="text-white" />
              <span>8:00 AM</span>
            </div>

            <div className="flex items-center gap-3">
              <FaMapMarkerAlt className="text-white" />
              <span>Chatkhil PG Govt high school</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SaveTheDate;
